import wixLocation from 'wix-location';

$w.onReady(function () {
 $w("#dropdown20").onChange((event) => {
  let url = $w('#dropdown20').value;
  wixLocation.to(url);
 });
});

$w.onReady(function () {
 $w("#dropdown27").onChange((event) => {
  let url = $w('#dropdown27').value;
  wixLocation.to(url);
 });
});

$w.onReady(function () {
 $w("#dropdown2").onChange((event) => {
  let url = $w('#dropdown2').value;
  wixLocation.to(url);
 });
});